import { Component, DoCheck, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { FunctionalityCode } from 'src/app/core/_enums/functionality.code';
import { GroupBy } from 'src/app/core/_enums/groupby';
import { SiteMapUrl } from 'src/app/core/_enums/sitemap.url';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { Member } from 'src/app/core/_models/member';
import { AuthService } from 'src/app/core/_services/auth.service';
import { MemberService } from 'src/app/core/_services/member.service';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { UpdateResourceAction } from 'src/app/store/actions/resource.actions';
import { AppState } from 'src/app/store/app.state';
import { DialogOverviewComponent } from '../shared/dialog-overview/dialog-overview.component';

@Component({
  selector: 'app-member',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.scss']
})
export class MemberComponent implements OnInit, DoCheck {
  form!: FormGroup;
  perimeterId!: string;
  acuView = false;

  profileTypes = [
    { value: 'entreprise_tp', label: 'member_type_entreprise_tp' },
    { value: 'moe', label: 'member_type_moe' },
    { value: 'moa', label: 'member_type_moa' },
    { value: 'fabricant', label: 'member_type_manufacturer' },
    { value: 'etudiant', label: 'member_type_student' }
  ];

  constructor(
    private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private memberService: MemberService,
    private dialog: MatDialog,
    private router: Router,
    private snackbarService: SnackbarService,
    private store: Store<AppState>,
    private translate: TranslateService,
    private authService: AuthService
  ) {
    this.perimeterId = history?.state?.perimeterId;

    this.form = this.formBuilder?.group({
      memberId: [],
      code: [null, Validators.required],
      displayName: [null, Validators.required],
      memberStatus: [],
      parent: ['USIRF'],
      isMO: [],
      profileType: [null, Validators.required],
      isSleepingMode: [],
      isRdfAdherent: []
    });
  }

  get formCrls() {
    return this.form?.controls;
  }

  ngDoCheck(): void {
    if (this.authService?.accessesValues) {
      this.acuView = this.authService.accessesValues.includes(FunctionalityCode.ACUView);
    }
  }

  ngOnInit(): void {
    this.activeRoute.params.subscribe((params) => {
      if (params?.id != '0') {
        this.memberService.get(params?.id).subscribe((member) => {
          this.form.patchValue(member);
        });
      } else {
        this.form.patchValue({});
      }
    });
  }

  clickDelete(memberId: string) {
    const dialogRef = this.dialog.open(DialogOverviewComponent, {
      data: { title: this.translate.instant('confirm_delete_member') }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteItem(memberId);
      }
    });
  }

  //Supprimer
  deleteItem(memberId: string) {
    if (memberId) {
      this.memberService.delete(memberId).subscribe({
        next: (data) => {
          this.majStore(SnackbarTypes.delete);
          this.router.navigate([SiteMapUrl.MenuMember]);
        },
        error: (error) => {
          this.snackbarService.open(SnackbarTypes.error);
          console.error(error);
        }
      });
    }
  }

  majStore(snackbarMsgType: string) {
    this.memberService.getAll(GroupBy.family).subscribe(
      (arr) => {
        if (arr) {
          //Ajouter la liste dans le store
          this.store.dispatch(new UpdateResourceAction(arr));
          this.snackbarService.open(snackbarMsgType);
        }
      },
      (error) => {
        this.snackbarService.open(SnackbarTypes.error);
      }
    );
  }

  //Cliquer sur le bouton enregistrer
  async clickSave(currentItem: Member) {
    if (this.form.invalid) {
      return;
    }

    const isUpdate = !!this.form?.value?.memberId;
    let rep = await this.onUpdateOrSaveAch(currentItem);
    rep.subscribe({
      next: (data: Member) => {
        this.majStore(isUpdate ? SnackbarTypes.update : SnackbarTypes.add);
        this.router.navigate([SiteMapUrl.MenuMember, data?.memberId]);
      },
      error: () => {
        this.snackbarService.open(SnackbarTypes.error);
      }
    });
  }

  //Sauvgarder ou modifier les données dans la base de données
  onUpdateOrSaveAch(currentItem: Member) {
    return this.form?.value?.memberId ? Promise.resolve(this.memberService.update(currentItem)) : Promise.resolve(this.memberService.add(currentItem));
  }

  //Mettre en sommeil
  clickSleep(member: Member) {
    member.isSleepingMode = !member.isSleepingMode;

    this.memberService.update(member).subscribe({
      next: (member) => {
        if (member) {
          this.form.patchValue(member);
        }
        this.snackbarService.open(SnackbarTypes.update);
      },
      error: () => {
        this.snackbarService.open(SnackbarTypes.error);
      }
    });
  }
}
